<div class="bar">
	<h3>Inactivity warning</h3>
	<p>You haven't made any changes to this page recently. You will be returned to preview mode in 30 seconds.</p>
	<p>Would you like to continue editing?</p>
	<button class="button positive renew">Yes</button>
	<button class="button negative cancel">No</button>
</div>
